import 'vue';
import { PARAGRAPH_TYPE, PARAGRAPH_RENDERED_NODE_NAME } from '../editor/module/paragraph/constant.js';
import { HTMLExtUtils } from '@ssml-editor/core';
import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { T as Text$1, a as Element$1 } from '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/index-B_A1dZu-.js';
import '../_virtual/lodash.js';
import { NodeUtils } from './node-utils.js';

const HtmlConverter = {
  slateElementToHtml(props, serializers) {
    for (const serializer of serializers) {
      if (NodeUtils.getNodeType(props.element) === serializer.type) {
        return serializer.serializer(props);
      }
    }
    return "";
  },
  slateNodeToHtml(nodes, serializers) {
    const htmlPart = [];
    for (const node of nodes) {
      if (Text$1.isText(node)) {
        htmlPart.push(node.text);
      } else if (Element$1.isElement(node)) {
        htmlPart.push(
          this.slateElementToHtml(
            {
              element: node,
              childrenHtml: this.slateNodeToHtml(node.children, serializers)
            },
            serializers
          )
        );
      }
    }
    return htmlPart.join("");
  },
  textToSlateNode(text, deserializers) {
    const type = PARAGRAPH_TYPE;
    const element = window.document.createElement(
      PARAGRAPH_RENDERED_NODE_NAME
    );
    const children = [{ text }];
    for (const deserializer of deserializers) {
      if (type === deserializer.type) {
        return deserializer.deserializer({ element, children });
      }
    }
    return null;
  },
  elementToSlateNode(element, deserializers) {
    const type = HTMLExtUtils.getType(element, PARAGRAPH_TYPE);
    const children = this.nodesToSlateNodes(
      [...element.childNodes],
      deserializers
    );
    if (children.length === 0) {
      children.push({ text: "" });
    }
    for (const deserializer of deserializers) {
      if (type === deserializer.type) {
        return deserializer.deserializer({ element, children });
      }
    }
    return null;
  },
  nodesToSlateNodes(nodes, deserializers) {
    const result = [];
    for (const node of nodes) {
      let slateNode = null;
      if (node instanceof Element) {
        slateNode = this.elementToSlateNode(node, deserializers);
      } else if (node instanceof Text) {
        slateNode = NodeUtils.createTextNode(node.textContent);
      }
      if (slateNode) {
        result.push(slateNode);
      }
    }
    return result;
  },
  htmlToSlateNodes(html, deserializers) {
    const parser = new DOMParser();
    const document = parser.parseFromString(html, "text/html");
    const nodes = [...document.body.childNodes];
    return this.nodesToSlateNodes(nodes, deserializers);
  }
};

export { HtmlConverter };
//# sourceMappingURL=html-converter.js.map
